var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHtml(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.27412 13.6505L0 0H14L12.7242 13.6484L6.99149 15.1667L1.27412 13.6505Z",
    fill: "#E44F26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14.0064L11.6326 12.7796L12.7225 1.11639H7V14.0064Z",
    fill: "#F1662A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99996 6.1787H4.6808L4.5209 4.46433H6.99996V2.79004H2.60547L2.64743 3.23962L3.07781 7.853H6.99996V6.1787V6.1787Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99967 10.5267L6.99173 10.5289L5.04001 10.0257L4.91526 8.69049H3.15576L3.40129 11.3187L6.99173 12.2709L6.99967 12.2687V10.5267Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99365 6.17889V7.85319H9.15177L8.94878 10.0247L6.99365 10.5285V12.2705L10.5869 11.3188L10.613 11.036L11.0247 6.62848L11.0678 6.17889H6.99365V6.17889Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99365 2.79004V4.46433H11.2271L11.2623 4.08841L11.3422 3.23962L11.3842 2.79004H6.99365V2.79004Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/Html.0b2a965364503dd1de0379e89e85d836.svg";
export { ForwardRef as ReactComponent };